var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal__shindan2col" }, [
      _c("div", { staticClass: "modal__shindan2colImg" }, [
        _c("img", { attrs: { src: _vm.result.imgPath } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal__shindan2colTxt" }, [
        _c("h3", { staticClass: "modal__shindan2colTxtTitle" }, [
          _vm._v(_vm._s(_vm.result.title)),
          _c("small", [_vm._v("にオススメなローファーは")]),
        ]),
        _vm._v(" "),
        _c("dl", [
          _c("dt", { domProps: { innerHTML: _vm._s(_vm.result.productName) } }),
          _vm._v(" "),
          _c("dd", [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.result.text) } }),
          ]),
        ]),
        _c(
          "a",
          {
            class: _vm.shindanBtnClass,
            attrs: {
              href: _vm.result.link,
              target: "_blank",
              "data-name": _vm.result.name,
            },
            on: {
              click: function ($event) {
                return _vm.click(_vm.result.id)
              },
            },
          },
          [
            _c("div", { staticClass: "shindanBtnClassInlineBlock" }, [
              _c("div", { staticClass: "shindanBtnClassFlex" }, [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.result.productBtnName) },
                }),
                _vm._v("はこちら"),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }